import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

/**
 * /l/:slug - resolves a short link via the API and redirects via window.location.
 * The API supports /l/{slug} on app level AND /api/go/{slug} — using /api/go to avoid
 * any ingress conflict with the frontend SPA routes.
 */
export default function ShortLinkRedirect() {
  const { slug } = useParams();
  useEffect(() => {
    const BACKEND = process.env.REACT_APP_BACKEND_URL;
    // Use the API go endpoint (which is reliably routed to backend).
    // It responds with a 302 redirect the browser will follow.
    window.location.replace(`${BACKEND}/api/go/${encodeURIComponent(slug)}`);
  }, [slug]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))]">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-2 border-[color:var(--brand-navy)] border-t-transparent animate-spin mx-auto mb-4" />
        <div className="font-display text-sm text-[color:var(--brand-navy)]">Redirection…</div>
      </div>
    </div>
  );
}
